import React from "react";
import styles from "../ResourcesReport.module.scss";

export function KPICardsSkeleton({ count = 14 }) {
  const gridCols = count <= 4 ? count : Math.ceil(count / 2);
  return (
    <div className={styles.kpiSection}>
      <div className={styles.kpiGrid} style={{ gridTemplateColumns: `repeat(${gridCols}, 1fr)` }}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className={styles.kpiCardSkeleton}>
            <div className={`${styles.shimmer} ${styles.skeletonIcon}`} />
            <div className={styles.skeletonContent}>
              <div className={`${styles.shimmer} ${styles.skeletonLabel}`} />
              <div className={`${styles.shimmer} ${styles.skeletonValue}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ChartsSkeleton() {
  return (
    <div className={styles.chartsSection}>
      <div className={styles.chartsHeader}>
        <div className={`${styles.shimmer} ${styles.skeletonToggle}`} />
        <div className={`${styles.shimmer} ${styles.skeletonToggleSmall}`} />
      </div>
      <div className={styles.chartsGrid}>
        {[0, 1].map((i) => (
          <div key={i} className={styles.chartCardSkeleton}>
            <div className={styles.skeletonChartHeader}>
              <div className={`${styles.shimmer} ${styles.skeletonChartTitle}`} />
              <div className={styles.skeletonLegendRow}>
                {Array.from({ length: 4 }).map((_, j) => (
                  <div key={j} className={`${styles.shimmer} ${styles.skeletonLegendDot}`} />
                ))}
              </div>
            </div>
            <div className={styles.skeletonChartArea}>
              {Array.from({ length: 8 }).map((_, j) => (
                <div
                  key={j}
                  className={`${styles.shimmer} ${styles.skeletonBar}`}
                  style={{ height: `${30 + Math.random() * 50}%` }}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function TableSkeleton({ rowCount = 8 }) {
  return (
    <div className={styles.tableSkeleton}>
      <div className={styles.skeletonTableHeader}>
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className={`${styles.shimmer} ${styles.skeletonHeaderCell}`} />
        ))}
      </div>
      {Array.from({ length: rowCount }).map((_, i) => (
        <div key={i} className={styles.skeletonTableRow}>
          {Array.from({ length: 6 }).map((_, j) => (
            <div key={j} className={`${styles.shimmer} ${styles.skeletonCell}`} />
          ))}
        </div>
      ))}
    </div>
  );
}
